module.exports = __webpack_public_path__ + "img/icon_help_contact.8a2d98b6.svg";